var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAxeIcone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.67 6.12",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#4d69fa;stroke-linecap:round;stroke-linejoin:round;}.cls-2{stroke-width:0.25px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "axe-icone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.82,
    y1: 0.5,
    x2: 2.08,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.61,
    y1: 5.62,
    x2: 2.16,
    y2: 5.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 0.83,
    y1: 2.15,
    x2: 14.81,
    y2: 2.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 0.72,
    y1: 3.83,
    x2: 14.7,
    y2: 3.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.5,5.56,15.21,4.27a.52.52,0,0,1-.16-.37V2.08a.2.2,0,0,1,.06-.14L16.55.5h2a.18.18,0,0,1,.14.06l1.39,1.38a.24.24,0,0,1,.05.14V4a.24.24,0,0,1-.05.14L18.73,5.56a.18.18,0,0,1-.14.06h-2A.16.16,0,0,1,16.5,5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,5.62h-2a.17.17,0,0,1-.14-.07L.55,4.1A.21.21,0,0,1,.5,4V2a.19.19,0,0,1,.05-.13L1.8.56A.16.16,0,0,1,1.93.5H4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxeIcone);
export default __webpack_public_path__ + "static/media/axe-icone.b0644cbf64329a3a3646d8d7608ba709.svg";
export { ForwardRef as ReactComponent };